import React, { PureComponent } from 'react';
import AnalysisCard from 'wt-react/dist/components/AnalysisCard/AnalysisCard.js';
import { formatDate } from '../../common/index.js';
import i18n from '../../i18n.js';
import './FundExposures.css';

const COLORS = {
    blue: '#0047BB',
    teal: '#05A9B1',
    grey: '#5B6770',
    orange: '#F68D2E',
    auburn: '#84344E',
    sky: '#00A9E0',
    green: '#658D1B',
    white: '#FFFFFF',
    silver: '#BDC2C6',
};

class FundExposures extends PureComponent {

    static defaultProps = {
        exposureType: 'sector',
        sliceCategoriesToN: null,
    };

    constructor(props) {
        super(props);

        this.state = {
            barColor: '#0047bb',
        };

        // Set up callback refs
        this.setStyleRef = element => {
            this.styleRef = element;
        };

        // This callback is call to set the style color when mounted
        this.getStyles = () => {
            if (this.styleRef) {
                this.setState({
                    barColor: getComputedStyle(this.styleRef).color,
                });
            }
        };
    }

    componentDidMount() {
        this.getStyles();
    }

    render() {

        const {
            data,
            exposureType,
            sliceCategoriesToN
        } = this.props;

        const {
            barColor,
        } = this.state;

        // Set up the table to be shown (based on which button is chosen)
        if (data && data[`${exposureType}Exposures`]) {

            const personalStrategy = {
                name: data.name,
                latestAnalysis: data,
                type: data.type,
            };

            // Find the latest index in the array (newest is last)
            const lastIndex = personalStrategy.latestAnalysis[`${exposureType}Exposures`].length - 1;

            // Add Sector data. Use color from css that can be overriden
            const seriesData = [{
                data: personalStrategy.latestAnalysis[`${exposureType}Exposures`][lastIndex].values,
                categories: personalStrategy.latestAnalysis[`${exposureType}Exposures`][lastIndex].keys.map( key =>{
                    return key
                    .replace('midCap', i18n.t('mid-cap'))
                    .replace('largeCap', i18n.t('large-cap'))
                    .replace('smallCap', i18n.t('small-cap'));
                }),
                name: personalStrategy.name,
                color: barColor, 
            }];

            return (
                    personalStrategy.latestAnalysis !== null &&
                    personalStrategy.latestAnalysis[`${exposureType}Exposures`] !== null ?
                    <div 
                        className='fund-exposures'
                    >
                        {/* This empty div is used to store the bar color so we can override in mac.css*/}
                        <div 
                            className='accent-color'
                            ref={this.setStyleRef}
                            key={exposureType}
                        >                                
                        </div>

                        <AnalysisCard
                            idOfCard={`${exposureType}-exposures`}
                            topOfAppId='fund-cards'
                            key={`${exposureType}-${personalStrategy.name}`}
                            chartType='bar'
                            cardTitle={i18n.t(exposureType)}
                            showChartLabels={true}
                            heroTitle={i18n.t(`${exposureType}-exposures-title`)}
                            showLegend={false}
                            categoryIsDate={false}
                            seriesData={seriesData}
                            showGrid={true}
                            showAxes={true}
                            footnoteText={i18n.t(`${exposureType}-exposures-footnote`)
                                .replace('[[ASOF]]', formatDate(personalStrategy.latestAnalysis[`${exposureType}Exposures`][lastIndex].date))}
                            showDetailsOnHover={false}
                            seriesColor={COLORS.blue}
                            seriesIsPercentage={true}
                            sliceCategoriesToN={sliceCategoriesToN}
                        />

                    </div>
                    : null
            );
        }
            return null;
            
        }
    }

    export default(FundExposures);
